module.exports = __webpack_public_path__ + "blueprint-2_decol_o.d466e2c2069dda85c5c12a409a130fbb.svg";